import { Map } from 'immutable';

import {
  ORGANIZATIONS__CREATE,
  ORGANIZATIONS__DELETE,
  ORGANIZATIONS__DISCONNECT_FACEBOOK,
  ORGANIZATIONS__DISCONNECT_GIFTBIT,
  ORGANIZATIONS__FETCH,
  ORGANIZATIONS__FETCH_ONE,
  ORGANIZATIONS__REMOVE_BG_IMAGE,
  ORGANIZATIONS__REMOVE_LOGO,
  ORGANIZATIONS__UPDATE,
  ORGANIZATIONS__UPDATE_FEATURE,
  ORGANIZATIONS__FETCH_TWILIO_DATA,
  USER__LOG_IN,
  USER__LOG_OFF,
} from '../constants';
import { getBeginType } from '../api-client/selectors.api-client';

import { mergeJsonArray } from '../../util';

const defaultState = new Map();

const patchFeature = (state, { organization, data: { name } }) => {
  const features = organization.features.map((feature) => {
    if (feature.name !== name) return feature;
    return { ...feature, isActive: !feature.isActive };
  });
  const nextOrganization = { ...organization, features };
  return mergeJsonArray(state, [nextOrganization]);
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case ORGANIZATIONS__CREATE:
    case ORGANIZATIONS__DISCONNECT_FACEBOOK:
    case ORGANIZATIONS__DISCONNECT_GIFTBIT:
    case ORGANIZATIONS__FETCH:
    case ORGANIZATIONS__FETCH_ONE:
    case ORGANIZATIONS__REMOVE_BG_IMAGE:
    case ORGANIZATIONS__REMOVE_LOGO:
    case ORGANIZATIONS__UPDATE:
    case ORGANIZATIONS__UPDATE_FEATURE:
    case ORGANIZATIONS__FETCH_TWILIO_DATA:
      return mergeJsonArray(state, action.data);
    case ORGANIZATIONS__DELETE:
      return state.delete(action.organizationId);
    case getBeginType(ORGANIZATIONS__UPDATE_FEATURE):
      return patchFeature(state, action);
    case USER__LOG_IN:
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}
